import NewFarmIcon from './newFarm.svg'
export const FarmRuminTechIcon = NewFarmIcon
